import { ALL_JSON_KEYS } from 'Constant';
import { IErrorHandling } from 'Container/OfferDisplay/types';
import {
    ERROR_HANDLING_SUCCESS_RESULT,
    JSON_AND_ARRAY_LENGTH_NOT_EQUAL,
    JSON_IS_NOT_VALID,
    JSON_LENGTH_IS_ZERO,
    JSON_VALIDATION_PROPERTY_ARRAY_ERROR,
    JSON_VALIDATION_PROPERTY_NOT_FOUND,
} from '../constant';

/**
 * Validates gigakombi-landingpage offerData json structure
 *
 * @param offerDataJson
 * @returns
 */
export const jsonOfferDataValidator = (offerDataJson: Object): IErrorHandling => {
    let result: IErrorHandling = { error: true, errorMessage: JSON_IS_NOT_VALID };

    for (const offerDataKey in offerDataJson) {
        result = jsonSimplePropertyValidator(offerDataJson[offerDataKey], ALL_JSON_KEYS);
        if (result.error) { return result; }
    }

    return result;
};

/**
 * Validates a simple JSON structure.
 *
 * @param json
 */
const jsonSimpleValidator = (json: Object): IErrorHandling => {
    const errorResult: IErrorHandling = { error: true, errorMessage: JSON_IS_NOT_VALID };

    if (!json) { return errorResult; }

    const properties = Object.keys(json);

    if (properties.length < 0) {
        errorResult.errorMessage = JSON_LENGTH_IS_ZERO;

        return errorResult;
    }

    return ERROR_HANDLING_SUCCESS_RESULT;
};

/**
 * Checks if all configured properties are present in the JSON.
 * ***WARNING: Only works for first child level of the JSON!***
 *
 * @param json
 * @param propertyNameArray
 * @returns
 */
const jsonSimplePropertyValidator = (json: Object, propertyNameArray: string[]): IErrorHandling => {
    const errorResult: IErrorHandling = { error: true, errorMessage: JSON_VALIDATION_PROPERTY_ARRAY_ERROR };

    if (!propertyNameArray) { return errorResult; }

    const jsonValidatorResult = jsonSimpleValidator(json);

    if (jsonValidatorResult.error) {
        return jsonValidatorResult;
    }

    const properties = Object.keys(json);

    if (properties.length !== propertyNameArray.length) {
        errorResult.errorMessage = JSON_AND_ARRAY_LENGTH_NOT_EQUAL(properties.length, propertyNameArray.length);

        return errorResult;
    }

    for (const propertyName of propertyNameArray) {
        if (json[propertyName] === undefined) {
            errorResult.errorMessage = JSON_VALIDATION_PROPERTY_NOT_FOUND(propertyName);

            return errorResult;
        }
    }

    return ERROR_HANDLING_SUCCESS_RESULT;
};
